// app/javascript/controllers/json_sender_controller.js

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["jsonInput", "token"]
  static values = { 
    authorization: String,
    serial: String 
  }

  submit(event) {
    event.preventDefault()
    
    const jsonInput = this.jsonInputTarget
    const form = this.element
    
    try {
      // Valida il JSON
      const jsonData = JSON.parse(jsonInput.value)
      
      // Crea un form temporaneo con i dati corretti
      const tempForm = document.createElement('form')
      tempForm.method = 'POST'
      tempForm.action = form.action
      
      // Aggiungi token CSRF
      const csrfToken = document.querySelector('meta[name="csrf-token"]').content
      this.addHiddenField(tempForm, 'authenticity_token', csrfToken)
      
      // Aggiungi Authorization
      this.addHiddenField(tempForm, 'Authorization', this.tokenTarget.value)
      
      // Aggiungi serialNoRemote
      // this.addHiddenField(tempForm, 'serialNoRemote', this.serialValue)
      
      // Aggiungi tutti i campi del JSON
      this.addJsonFields(tempForm, jsonData, '')
      
      // Invia il form
      document.body.appendChild(tempForm)
      tempForm.submit()
      
    } catch(e) {
      alert('Errore: JSON non valido!\n' + e.message)
      console.error('JSON parsing error:', e)
      return false
    }
  }

  addHiddenField(form, name, value) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    form.appendChild(input)
  }

  addJsonFields(form, obj, prefix) {
    Object.keys(obj).forEach(key => {
      const fieldName = prefix ? `${prefix}[${key}]` : key
      
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        this.addJsonFields(form, obj[key], fieldName)
      } else {
        this.addHiddenField(form, fieldName, obj[key])
      }
    })
  }

  // Opzionale: validazione in tempo reale
  connect() {
    // Aggiungi event listener per validazione mentre si digita
    this.jsonInputTarget.addEventListener('blur', () => {
      this.validateJson()
    })
  }

  validateJson() {
    try {
      JSON.parse(this.jsonInputTarget.value)
      this.jsonInputTarget.style.borderColor = ''
      this.jsonInputTarget.setCustomValidity('')
    } catch(e) {
      this.jsonInputTarget.style.borderColor = '#ff0000'
      this.jsonInputTarget.setCustomValidity('JSON non valido: ' + e.message)
    }
  }
}